<template>
  <div>
    <div class="custom-container">
      <b-row>
        <b-col sm="12">
          <card class="p-0">
            <template class="p-0" v-slot:headerTitle>
              <div class="d-flex flex-column align-items-start">
                <h3 class="card-title p-0">
                  <b>Herramientas</b>
                </h3>
              </div>
            </template>
            <div class="row p-3 px-3">
              <div class="col-lg-2">
                <h4 class="mb-2"><b>Mes:</b></h4>
                <b-select v-model="mesSeleccionado" class="form-control bg-dark personalizado" :options="listaMes" text-field="mes" value-field="id" />
              </div>
              <div class="col-lg-1 px-1">
                <h4 class="mb-2"><b>Año:</b></h4>
                <b-select v-model="anioSeleccionado" class="form-control bg-dark personalizado" :options="listaAnios" />
              </div>
            </div>
            <b-tabs content-class="mt-3 px-3" justified>
              <b-tab title="Profesionales con especialidad y porcentajes" active>
                <div>
                  <div class="d-flex">
                    <vs-button primary class="px-1 py-1 mr-auto" @click="verProfesionalesYPorcentaje()" id="sendform2">
                      <i class="fas fa-search mr-1"></i> Ver Lista de profesionales
                    </vs-button>
                  </div>
                  <!-- <div class="m-3">
                    <h4><b>Liquidaciones realizadas y pendientes</b></h4>
                    <p>
                      {{ `Liquidados = ${liquidados} / Pendientes = ${pendientes}` }}
                    </p>
                  </div> -->
                  <!-- <data-table :data="listaProfesionalesYPorcentajes" :headers="encabezadostablaJson[1]" :items-per-page="itemsPerPage" /> -->
                  <b-table
                    id="listaProfesionalesYPorcentajes"
                    striped
                    bordered
                    hover
                    responsive
                    small
                    :items="listaProfesionalesYPorcentajes"
                    :fields="encabezadostablaJson[1]"
                    class="text-center"
                    :per-page="15"
                    :current-page="currentPage"
                  >
                    <template #cell(totalHonorarios)="data">
                      <span v-if="data.item.totalHonorarios" class="text-right">
                        {{
                          data.item.totalHonorarios.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                  </b-table>
                  <b-pagination v-model="currentPage" :total-rows="listaProfesionalesYPorcentajes.length" :per-page="perPage" align="center" class="my-3"></b-pagination>
                </div>
              </b-tab>
              <b-tab title="consolidar prestaciones">
                <div class="d-flex">
                  <vs-button success class="pr-3 py-1" @click="llenarConsolidado"> llenar consolidado prestaciones </vs-button>
                  <vs-button info class="px-2 py-1" @click="getConsolidados()" id="sendform2"> Lista consolidados </vs-button>

                  <vs-button primary class="px-2 py-1" @click="getHonorariosExito" id="sendform2"> Obtener honorarios </vs-button>
                </div>
                <div>
                  <vs-button v-if="listaConsolidados.length" icon success class="mx-1" @click="generateReport">
                    <i class="fas fa-file-excel mr-1"></i>
                    Exportar Reporte
                  </vs-button>
                  <!-- {{ listaConsolidados }} -->
                </div>
                <div class="">
                  <b-table
                    id="datatable_ttos"
                    striped
                    bordered
                    hover
                    responsive
                    small
                    :items="listaConsolidados"
                    :fields="fieldsListaConsolidados"
                    class="text-center"
                    :per-page="perPage"
                    :current-page="currentPage"
                  >
                    <template #cell(totalHonorarios)="data">
                      <span v-if="data.item.totalHonorarios" class="text-right">
                        {{
                          data.item.totalHonorarios.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totalDevengos)="data">
                      <span v-if="data.item.totalDevengos" class="text-right">
                        {{
                          data.item.totalDevengos.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(retencionEnLaFuente)="data">
                      <span v-if="data.item.retencionEnLaFuente" class="text-right">
                        {{
                          data.item.retencionEnLaFuente.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totalIca)="data">
                      <span v-if="data.item.totalIca" class="text-right">
                        {{
                          data.item.totalIca.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(otrasDeducciones)="data">
                      <span v-if="data.item.otrasDeducciones" class="text-right">
                        {{
                          data.item.otrasDeducciones.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(descuentoGarantias)="data">
                      <span v-if="data.item.descuentoGarantias" class="text-right">
                        {{
                          data.item.descuentoGarantias.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totalDeducciones)="data">
                      <span v-if="data.item.totalDeducciones" class="text-right">
                        {{
                          data.item.totalDeducciones.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totTosRealizados)="data">
                      <span v-if="data.item.totTosRealizados" class="text-right">
                        {{
                          data.item.totTosRealizados.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totCostosMatEspecial)="data">
                      <span v-if="data.item.totCostosMatEspecial" class="text-right">
                        {{
                          data.item.totCostosMatEspecial.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totCostosRemision)="data">
                      <span v-if="data.item.totCostosRemision" class="text-right">
                        {{
                          data.item.totCostosRemision.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totCostosLaboratorio)="data">
                      <span v-if="data.item.totCostosLaboratorio" class="text-right">
                        {{
                          data.item.totCostosLaboratorio.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totAgregados)="data">
                      <span v-if="data.item.totAgregados" class="text-right">
                        {{
                          data.item.totAgregados.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totDescuentos)="data">
                      <span v-if="data.item.totDescuentos" class="text-right">
                        {{
                          data.item.totDescuentos.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(subTotal)="data">
                      <span v-if="data.item.subTotal" class="text-right">
                        {{
                          data.item.subTotal.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(totAgregadosExcluidos)="data">
                      <span v-if="data.item.totAgregadosExcluidos" class="text-right">
                        {{ data.item.totAgregadosExcluidos.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                      </span>
                    </template>
                    <template #cell(totDescuentosExcluidos)="data">
                      <span v-if="data.item.totDescuentosExcluidos" class="text-right">
                        {{ data.item.totDescuentosExcluidos.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                      </span>
                    </template>
                    <template #cell(porcentaje)="data">
                      <span v-if="data.item.porcentaje" class="text-right">
                        {{ data.item.porcentaje + "%" }}
                      </span>
                    </template>
                    <template #cell(totalAPagar)="data">
                      <span v-if="data.item.totalAPagar" class="text-right">
                        {{
                          data.item.totalAPagar.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </span>
                    </template>
                  </b-table>
                  <b-pagination v-model="currentPage" :total-rows="listaConsolidados.length" :per-page="perPage" align="center" class="my-3"></b-pagination>
                </div>
              </b-tab>
              <b-tab title="Liquidaciones realizadas y pendientes">
                <div>
                  <div class="d-flex">
                    <vs-button primary class="px-2 py-1 ml-auto" @click="filtrar(1)" id="sendform2">
                      <i class="fas fa-search mr-1"></i> Ver Liquidaciones realizadas y pendientes
                    </vs-button>
                  </div>
                  <div class="m-3">
                    <h4><b>Liquidaciones realizadas y pendientes</b></h4>
                    <p>
                      {{ `Liquidados = ${liquidados} / Pendientes = ${pendientes}` }}
                    </p>
                  </div>
                  <data-table :data="liquidaciones" :headers="encabezadostablaJson[0]" :items-per-page="itemsPerPage" />
                </div>
                <!-- Costos material especial	 -->
                <div class="mt-4">
                  <div class="m-3">
                    <h4><b>Resumen de liquidaciones </b></h4>
                  </div>

                  <table id="datatable_ttos" class="table table-bordered table-responsive-md table-striped text-center">
                    <thead>
                      <tr>
                        <th>Identificación Paciente</th>
                        <th>Paciente nombre</th>
                        <th>Ttos realizados</th>
                        <th>Mat. Especial</th>
                        <th>C. Remisión</th>
                        <th>C. Laboratorio</th>
                        <th>T. Agregados</th>
                        <th>T. Descuentos</th>
                        <th>Neto Honorarios</th>
                        <th>Total</th>
                        <!-- <th>Valor</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in listaItemsMaterial" :key="item.id">
                        <td>
                          {{ item.rut }}
                        </td>
                        <td>
                          {{ item.pacienteNombre }}
                        </td>
                        <td>
                          {{ item.concepto }}
                        </td>
                        <td>
                          {{ item.descripcion }}
                        </td>
                        <td>
                          {{ item.tipo }}
                        </td>
                        <td>
                          {{ item.valor.toFixed(0) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
            </b-tabs>

            <!-- <div class="mx-3">
              <b-button v-if="profesional" variant="info" class="float-left mt-3 mr-3" @click="verResumen()">Ver Resumen</b-button>
            </div> -->

            <div class="px-3 pt-3">
              <!-- <div class="text-center py-2">
                <label class="h5"
                  ><b>{{ profesional != null ? profesional.nombreProfesional : "" }}</b>
                </label>
              </div> -->
            </div>
          </card>
        </b-col>
      </b-row>
    </div>
    <b-modal id="table" class="p-3" title="tabla" size="lg" hide-footer centered>
      <div>
        <!-- <h1>Tabla</h1> -->
        <tablaLiquidacion name="tabla"></tablaLiquidacion>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { core } from "../../../../config/pluginInit";
import dataTable from "./TablaComponente.vue";
import tablaLiquidacion from "../../../../components/helexium/tablaLiquidacion.vue";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

// import moment_timezone from "moment-timezone";
// import CardTable from "../../../../components/cardTable/CardTable.vue";
// import CardTable from "@/components/cardTable/CardTableV2.vue";
// import CardTable from "@/components/cardTable/CardTableV3.vue";
// import * as XLSX from "xlsx";

// import BtnAddCardTable from "../../../../components/btnCardTable/btnAddCardTable.vue";

// const Swal = require("sweetalert2");
export default {
  name: "registroServicios",
  components: {
    dataTable,
    tablaLiquidacion,
    // CardTable,
    // BtnAddCardTable,
  },
  data() {
    return {
      encabezadostablaJson: [
        //ttos realizados
        [
          { header: "Identificación del profesional", key: "rutProfesional" },
          { header: "Sucursal", key: "sucursal" },
          { header: "Profesional", key: "profesional" },
          { header: "Liquidado", key: "contador" },
        ],
        [
          { header: "Id", key: "id", sortable: true },
          { header: "N° Documento", key: "numeroDocumento", sortable: true },
          { header: "nombre", key: "nombres", sortable: true },
          { header: "Especialidad", key: "especialidad", sortable: true },
          { header: "Porcentaje", key: "porcentaje", sortable: true },

          // { header: "Sucursal", key: "sucursal" },
          // { header: "Profesional", key: "profesional" },
          // { header: "Liquidado", key: "contador" },
        ],
      ],
      liquidaciones: [],
      liquidados: 0,
      pendientes: 0,
      row: [
        {
          id: 1,
          rutProfesional: 123,
          Sucursal: "testS",
          Profesional: "testN",
          Contador: 1,
        },
        {
          id: 2,
          rutProfesional: 123,
          Sucursal: "testS",
          Profesional: "testN",
          Contador: 1,
        },
        {
          id: 3,
          rutProfesional: 123,
          Sucursal: "testS",
          Profesional: "testN",
          Contador: 1,
        },
        {
          id: 4,
          rutProfesional: 123,
          Sucursal: "testS",
          Profesional: "testN",
          Contador: 1,
        },
      ],
      listaMes: [
        { id: 1, mes: "Enero" },
        { id: 2, mes: "Febrero" },
        { id: 3, mes: "Marzo" },
        { id: 4, mes: "Abril" },
        { id: 5, mes: "Mayo" },
        { id: 6, mes: "Junio" },
        { id: 7, mes: "Julio" },
        { id: 8, mes: "Agosto" },
        { id: 9, mes: "Septiembre" },
        { id: 10, mes: "Octubre" },
        { id: 11, mes: "Noviembre" },
        { id: 12, mes: "Diciembre" },
      ],
      listaAnios: [],
      mesSeleccionado: null,
      anioSeleccionado: null,
      persona: {},
      dataTableInstance: null,
      listaPacientes: [],
      listaProfesional: [],
      listaSucursal: [],
      listaItems: [],
      listaItemsbk: [],
      honorariosExitoData: [],
      paciente: null,
      profesional: null,
      sucursal: null,
      listaItemsMaterial: [],
      itemsPerPage: 10,

      consolidadoLista: [],
      listaConsolidar: [],
      listaIca: [],
      listaConsolidados: [],
      fieldsListaConsolidados: [
        { key: "id", sortable: true },
        { key: "rutProfesional", sortable: true },
        { key: "profesionalNombre", sortable: true },
        { key: "mes", sortable: true },
        { key: "anio", sortable: true },
        { key: "especialidad", sortable: true },
        { key: "sucursal", sortable: true },
        { key: "totTosRealizados", sortable: true },
        { key: "totCostosMatEspecial", sortable: true },
        { key: "totCostosRemision", sortable: true },
        { key: "totCostosLaboratorio", sortable: true },
        { key: "totAgregados", sortable: true },
        { key: "totDescuentos", sortable: true },
        { key: "totAgregadosExcluidos", sortable: true },
        { key: "totDescuentosExcluidos", sortable: true },
        { key: "porcentaje", sortable: true },
        { key: "valorNetoHonorarios", sortable: true },
        { key: "subTotal", sortable: true },
        { key: "totalAPagar", sortable: true },

        { key: "totalHonorarios", sortable: true },
        // { key: "banco", sortable: true },
        // { key: "tipo", sortable: true },
        // { key: "numero", sortable: true },
        // { key: "primerosAbonos", sortable: true },
        // { key: "cierresOrtodoncia", sortable: true },
        // { key: "remisionImplantes", sortable: true },
        // { key: "montajesOrtodoncia", sortable: true },
        // { key: "inicios", sortable: true },
        // { key: "packs", sortable: true },
        // { key: "notaDebitoConvenios", sortable: true },
        // { key: "incrementoOcasional", sortable: true },
        // { key: "concurso", sortable: true },
        // { key: "totalInc", sortable: true },
        // { key: "pagoGarantias", sortable: true },
        { key: "totalDevengos", sortable: true },
        { key: "articuloRetencion", sortable: true },
        // { key: "qporciento", sortable: true },
        // { key: "iBC", sortable: true },
        // { key: "sS", sortable: true },
        // { key: "coopserpark", sortable: true },
        // { key: "segBolivar", sortable: true },
        // { key: "celular", sortable: true },
        { key: "gastosFinancieros", sortable: true },
        { key: "retencionEnLaFuente", sortable: true },
        { key: "totalIca", sortable: true },
        { key: "otrasDeducciones", sortable: true },
        { key: "descuentoGarantias", sortable: true },
        { key: "totalDeducciones", sortable: true },
        { key: "totalHonorariosExito", sortable: true },
        // { key: "dS", sortable: true },
        // { key: "observaciones", sortable: true },
      ],
      perPage: 7,
      currentPage: 1,
      listaProfesionalesYPorcentajes: [],
    };
  },
  async mounted() {
    const anioActual = new Date().getFullYear();
    const anioInicio = anioActual - 2;
    const listaAnios = [];
    await this.getIca();
    for (let anio = anioInicio; anio <= anioActual; anio++) {
      listaAnios.push(anio);
    }
    this.listaAnios = listaAnios;
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.listaItems = [];
    this.mesSeleccionado = new Date().getMonth();
    this.anioSeleccionado = new Date().getFullYear();
    // this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(this.anioSeleccionado, this.mesSeleccionado);
    if (window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
      window.$("#datatable_registroServicios").DataTable().destroy();
    }

    core.index();
  },
  methods: {
    async verProfesionalesYPorcentaje() {
      //obtener lista de profesionales de dentisalud con especialidad
      const path = `Persona/ListProfesionalEspecialidad/` + this.persona.empresa.id;
      // let res = await this.$store.dispatch("denti_get", { path });
      let res = await this.$store.dispatch("hl_get", { path });
      let contador = 1;
      let res2 = res.map((item) => ({
        id: contador++,
        numeroDocumento: item.numeroDocumento ?? "",
        nombres: [item.nombres, item.segundoNombre, item.apellidos, item.SegundoApellido].filter(Boolean).join(" ").trim(),
        especialidad: item.especialidad ?? "",
        porcentaje: "",
      }));
      //if (res.length > 0) {
      // Parsear los datos de Excel
      ///const parsedData = JSON.parse(success);
      this.listaProfesionalesYPorcentajes = res2;
      //}
      //
    },
    async getHonorariosExito() {
      const path = `HonorariosExitoTemp/Obtener/${this.anioSeleccionado}/${this.mesSeleccionado}`;
      let res = await this.$store.dispatch("denti_get", { path });
      console.log("res-getHonorariosExito-----", res);
      const { success, data } = res;
      if (success && data !== null) {
        // Parsear los datos de Excel
        const parsedData = JSON.parse(data.data);
        this.honorariosExitoData = parsedData;
      } else {
        console.log("No se encontraron datos");
        this.honorariosExitoData = [];
      }
    },
    generateReport() {
      // const ws = XLSX.utils.json_to_sheet(this.listaConsolidados);
      // const wb = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, "Reporte");
      let dataEncabezado = [
        "id",
        "rutProfesional",
        "profesionalNombre",
        "mes",
        "anio",
        "especialidad",
        "sucursal",
        "totTosRealizados",
        "totCostosMatEspecial",
        "totCostosRemision",
        "totCostosLaboratorio",
        "totAgregados",
        "totDescuentos",
        "totAgregadosExcluidos",
        "totDescuentosExcluidos",
        "porcentaje",
        "valorNetoHonorarios",
        "subTotal",
        "totalAPagar",
        "totalHonorarios",
        "totalDevengos",
        "articuloRetencion",
        "gastosFinancieros",
        "retencionEnLaFuente",
        "totalIca",
        "otrasDeducciones",
        "descuentoGarantias",
        "totalDeducciones",
        "totalHonorariosExito",
      ];
      // XLSX.writeFile(wb, "consolidar_profesionales.xlsx");

      let data = this.listaConsolidados.map(
        ({
          id,
          rutProfesional,
          profesionalNombre,
          mes,
          anio,
          especialidad,
          sucursal,
          totTosRealizados,
          totCostosMatEspecial,
          totCostosRemision,
          totCostosLaboratorio,
          totAgregados,
          totDescuentos,
          totAgregadosExcluidos,
          totDescuentosExcluidos,
          porcentaje,
          valorNetoHonorarios,
          subTotal,
          totalAPagar,
          totalHonorarios,
          totalDevengos,
          articuloRetencion,
          gastosFinancieros,
          retencionEnLaFuente,
          totalIca,
          otrasDeducciones,
          descuentoGarantias,
          totalDeducciones,
          totalHonorariosExito,
        }) => [
          id,
          rutProfesional,
          profesionalNombre,
          mes,
          anio,
          especialidad,
          sucursal,
          totTosRealizados,
          totCostosMatEspecial,
          totCostosRemision,
          totCostosLaboratorio,
          totAgregados,
          totDescuentos,
          totAgregadosExcluidos,
          totDescuentosExcluidos,
          porcentaje,
          valorNetoHonorarios,
          subTotal,
          totalAPagar,
          totalHonorarios,
          totalDevengos,
          articuloRetencion,
          gastosFinancieros,
          retencionEnLaFuente,
          totalIca,
          otrasDeducciones,
          descuentoGarantias,
          totalDeducciones,
          totalHonorariosExito,
        ]
      );
      let dataFull = [dataEncabezado, ...data];
      console.log(dataFull);
      const ws = XLSX.utils.aoa_to_sheet(dataFull);

      // Crear un nuevo libro de Excel y agregar la hoja
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reporte");

      // Generar y descargar el archivo XLSX
      XLSX.writeFile(wb, "Consolidar.xlsx");

      // Crear la hoja de cálculo a partir de los datos
      // const ws = XLSX.utils.aoa_to_sheet(data);

      // // Crear un nuevo libro de Excel y agregar la hoja
      // const wb = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, "Reporte");

      // // Generar y descargar el archivo XLSX
      // XLSX.writeFile(wb, "Consolidar.xlsx");
    },
    async getConsolidados() {
      try {
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/getMSMisHonorariosGeneral/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
        });
        this.listaConsolidados = res;
        console.log("lista consolidados -----", this.listaConsolidados);
      } catch (error) {
        this.listaConsolidados = [];
        console.log("error", error);
      }
    },
    async llenarConsolidado() {
      // paso 1 ejecutar sp [consolidarHonorariosProduccion] en server dentisalud solamente llena algunos campos
      try {
        this.$isLoading(true);
        0;
        await this.getHonorariosExito();
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/getMSMisHonorariosGeneral/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
        });
        // console.log("despues del gethonorariosgral", res);
        this.consolidadoLista = res;
        this.$forceUpdate();

        //paso 2 generar lista de profesionales con distinct del periodo y traerlo al front para obtener numero del articulo para ret. de cada profesional,
        // let rutsUnicos = [...new Set(this.consolidadoLista.map((p) => p.rutProfesional))];
        // let rutsUnicos = [
        //   ...new Map(
        //     this.consolidadoLista.map((item) => [
        //       item.rutProfesional,
        //       item.rutProfesional,
        //     ])
        //   ).values(),
        // ];

        // console.log("rutsunicos-->", rutsUnicos);
        // console.log("iniciando for");
        let resPost = await this.$store.dispatch("hl_get", {
          path: "Persona/GetListaRetencionEnLaFuenteArt/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
        });
        // console.log("respost", resPost);

        // for await (let persona of rutsUnicos) {
        //   console.log(persona.rutProfesional);
        //   let result = await this.$store.dispatch("hl_get", {
        //     path: "Persona/GetPersonaRetencionEnLaFuenteArt/" + persona.rutProfesional + "/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
        //   });
        //   console.log("profesional ", result);
        // }

        // paso 3 realizar calculos de campos pendientes como ret en la fuente, ica etc por cada profesional,
        this.listaConsolidar = [];
        for await (let profesional of this.consolidadoLista) {
          // let totalHonorariosExito = this.honorariosExitoData.find((x) => x.)
          //obtener articulo para retencion en la fuente

          // console.log(
          //   "this.profesional.rut-getHonorariosExito----",
          //   profesional.rutProfesional
          // );
          let honorariosExitoXProfesional = this.honorariosExitoData.excelData.filter(
            (row, idx) => (row[0] == profesional.sucursal && row[1] == profesional.rutProfesional) || idx === 0
          );
          honorariosExitoXProfesional = honorariosExitoXProfesional.length > 0 ? honorariosExitoXProfesional.reduce((total, row) => total + row[row.length - 1], 0) : 0;
          honorariosExitoXProfesional = honorariosExitoXProfesional.toFixed(2);
          console.log("honorariosExitoXProfesional-------", honorariosExitoXProfesional);
          console.log("profesional.rutProfesional-------", profesional.rutProfesional);

          ///////////////////////////
          let totalHonorarios = profesional.totalHonorarios + Number(honorariosExitoXProfesional);
          //////////////////////////
          // console.log(
          //   "honorariosExitoXProfesional----",
          //   honorariosExitoXProfesional.length > 0 ? honorariosExitoXProfesional.reduce((total, row) => total + row[row.length - 1], 0) : 0
          // );

          let articuloRetencion = resPost.find((x) => x.numeroDocumento == profesional.rutProfesional);
          //console.log("****");
          // retencion en la fuente
          let dataIca = this.listaIca.filter((x) => x.sedeHelexium == profesional.sucursal)[0];
          //console.log("DATAICA ", JSON.stringify(dataIca));
          let ica = Math.round(totalHonorarios * dataIca.tarifaFinal);
          let gastosFinancieros = 6000;
          let retencion =
            articuloRetencion != undefined && articuloRetencion.calculoArt == 392 ? Math.round(totalHonorarios * 0.11) : Math.round(this.calculoRetencion383(totalHonorarios));
          let nombreProfesional =
            (articuloRetencion != undefined ? articuloRetencion.nombres : "") +
            " " +
            (articuloRetencion != undefined ? articuloRetencion.segundoNombre : "") +
            " " +
            (articuloRetencion != undefined ? articuloRetencion.apellidos : "") +
            " " +
            (articuloRetencion != undefined ? articuloRetencion.segundoApellido : "");
          let dataConsolidar = {
            TotalHonorariosExito: honorariosExitoXProfesional,
            totalHonorarios: totalHonorarios,
            id: profesional.id,
            ProfesionalNombre: nombreProfesional,
            rutProfesional: profesional.rutProfesional,
            ArticuloRetencion: articuloRetencion != undefined ? articuloRetencion.calculoArt : 0,
            Especialidad: articuloRetencion != undefined ? articuloRetencion.especialidad : "",
            gastosFinancieros: gastosFinancieros,
            RetencionEnLaFuente: retencion,
            TotalIca: ica,
            TotalDeducciones: Math.round(Number(profesional.otrasDeducciones) + Number(profesional.descuentoGarantias) + Number(retencion) + Number(ica)) + gastosFinancieros,
            TotalAPagar:
              Math.round(totalHonorarios) -
              Math.round(Number(profesional.otrasDeducciones) + Number(profesional.descuentoGarantias) + Number(retencion) + Number(ica) + gastosFinancieros),
          };
          this.listaConsolidar.push(dataConsolidar);
        }
        let resActualiza = await this.$store.dispatch("denti_post", {
          path: "Prestaciones/ActualizarSMisHonorariosGeneral/",
          data: this.listaConsolidar,
        });
        console.log("resActualiza-----", resActualiza);
        Swal.fire("Perfecto!", "Proceso finalizado.", "success");
        this.$isLoading(false);
        // paso 4 enviar toda esa data al backend dentisalud para que actualice tabla general
      } catch (error) {
        this.$isLoading(false);
        console.log("error", error);
      }
    },
    ///////////////////
    // showModalResumen2() {
    //   let retencion =
    //     this.CodigoRetencionEnLaFuente != null && this.CodigoRetencionEnLaFuente.calculoArt && this.CodigoRetencionEnLaFuente.calculoArt == 392
    //       ? Math.round(this.totalFinalNetoHonorarios * 0.11)
    //       : Math.round(this.calculoRetencion383(this.totalFinalNetoHonorarios));
    //   let ica = Math.round(this.totalFinalNetoHonorarios * this.dataIca.tarifaFinal);
    //   let gastosFinancieros = 6000;
    //   let totalDeducciones = Math.round(Number(sumaOtrasDeducciones) + Number(sumaGarantias) + Number(retencion) + Number(ica) + Number(gastosFinancieros));
    //   this.ResumenLiquida = {
    //     gastosFinancieros: gastosFinancieros,
    //     valorAFacturar: Math.round(this.totalFinalNetoHonorarios),
    //     retencionEnLaFuente: retencion,
    //     ica: ica,
    //     otrasDeducciones: sumaOtrasDeducciones,
    //     garantias: sumaGarantias,
    //     totalDeducciones: totalDeducciones,
    //     totalAPagar: Math.round(this.totalFinalNetoHonorarios - totalDeducciones),
    //   };
    //   this.$bvModal.show("ModalResumen2");
    // },
    calculoRetencion383(base) {
      //console.log("base base", base);
      let baseAportes = (base * 0.4).toFixed(2);
      //console.log("base baseAportes ", baseAportes);
      let aportesObligatoriosFP = (baseAportes * 0.16).toFixed(2);
      //console.log("base aportesObligatoriosFP ", aportesObligatoriosFP);
      let aportesObligatorioS = (baseAportes * 0.125).toFixed(2);
      //console.log("base aportesObligatorioS ", aportesObligatorioS);
      let totingresosnrngo = (Number(aportesObligatoriosFP) + Number(aportesObligatorioS)).toFixed(2);
      //console.log("base totingresosnrngo ", totingresosnrngo);
      let subtotal1 = (Number(base) - Number(totingresosnrngo)).toFixed(2);
      //console.log("base subtotal1 ", subtotal1);
      //let limite30Porciento = (Number(base) * 0.3).toFixed(2);
      //console.log("base limite30Porciento ", limite30Porciento);
      let subTotal3 = Number(subtotal1);
      //console.log("base subTotal3 ", subTotal3);
      let rentasExentas = Number(subTotal3 * 0.25);
      //console.log("base rentasExcentas ", rentasExentas);
      //let totalRentasExentas = Number(rentasExentas);
      //console.log("base totalRentasExentas ", totalRentasExentas);
      let baseGravableInicial = Number(subTotal3 - rentasExentas).toFixed(2);
      //console.log("base baseGravableInicial ", baseGravableInicial);
      //let deduccionesMasRentasExentas = Number(totalRentasExentas).toFixed(2);
      //console.log(
      //  "base deduccionesMasRentasExentas ",
      //  deduccionesMasRentasExentas
      //);
      //let MaximoVlrDedMasRExentas = Number(subtotal1 * 0.4).toFixed(2);
      //console.log("base MaximoVlrDedMasRExentas ", MaximoVlrDedMasRExentas);
      let BaseMensualDeRetencion = Number(baseGravableInicial).toFixed(2);
      //console.log("base BaseMensualDeRetencion ", BaseMensualDeRetencion);
      //let ValorUVT2024 = 49799;
      //console.log("base ValorUVT2024 ", ValorUVT2024);
      let ValorSalarioGravableUVT = Number(BaseMensualDeRetencion);
      //console.log("base ValorSalarioGravableUVT ", ValorSalarioGravableUVT);
      let retencion = this.calcularRetencionFuente(Number(ValorSalarioGravableUVT));
      //console.log("base la retencion es", retencion);
      return retencion;
    },
    calcularRetencionFuente(ingresoMensualCOP) {
      // const UVT_2025 = 47065;
      const UVT_2025 = 49799;
      const ingresoUVT = ingresoMensualCOP / UVT_2025;
      // console.log("base ingresouvt", ingresoUVT);
      let retencionUVT = 0;

      if (ingresoUVT <= 95) {
        retencionUVT = 0;
      } else if (ingresoUVT <= 150) {
        retencionUVT = (ingresoUVT - 95) * 0.19;
      } else if (ingresoUVT <= 360) {
        retencionUVT = (ingresoUVT - 150) * 0.28 + 10.45;
      } else if (ingresoUVT <= 640) {
        retencionUVT = (ingresoUVT - 360) * 0.33 + 69.29;
      } else if (ingresoUVT <= 945) {
        retencionUVT = (ingresoUVT - 640) * 0.35 + 162.49;
      } else if (ingresoUVT <= 2300) {
        retencionUVT = (ingresoUVT - 945) * 0.37 + 268.84;
      } else {
        retencionUVT = (ingresoUVT - 2300) * 0.39 + 770.06;
      }

      const retencionCOP = Math.round(retencionUVT * UVT_2025);
      console.log({
        ingresoMensualCOP: ingresoMensualCOP,
        ingresoMensualUVT: ingresoUVT.toFixed(2),
        retencionUVT: retencionUVT.toFixed(2),
        retencionCOP: retencionCOP,
      });
      return retencionCOP;
    },
    async getIca() {
      try {
        this.listaItems = [];

        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ListaTablaIca/",
        });
        this.listaIca = res;
      } catch (error) {
        console.log("err", error);
      }
    },

    ///////////////
    modal() {
      console.log("entro");
      this.$bvModal.show("table");
    },
    cadenaMes() {
      let numero = this.mesSeleccionado;
      const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      // Verificar que el número esté en el rango válido (1-12)
      if (numero < 1 || numero > 12) {
        return "Número inválido. Debe estar entre 1 y 12.";
      }

      // Restar 1 para obtener el índice correcto del mes
      return meses[numero - 1];
    },
    getTabla() {
      // try {
      //   let res = await this.$store.dispatch("denti_get", {
      //     path: "Prestaciones/ListaProfesionalesPorPeriodo/" + primerDia + "/" + ultimoDia,
      //   });
      //   this.row = res
      // } catch (error) {
      //   console.log('error',error)
      // }
    },
    filterData() {
      // if (item == 1) {
      //   this.profesional = null;
      //   this.sucursal = null;
      //   ////////
      //   this.$isLoading(true);
      //   //filtrar x mes y año
      //   let mesSeleccionado = new Date(this.anioSeleccionado + "/" + this.mesSeleccionado + "/01").getMonth();
      //   let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
      //   this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(anioSeleccionado, mesSeleccionado);
      //   await this.getTabla(this.Periodo.primerDia, this.Periodo.ultimoDia);
      //   this.$isLoading(false);
      // }
    },
    // obtenerSucursales() {
    //   alert("asd");
    // },
    // verResumen() {
    //   this.$bvModal.show("resumen");
    // },
    // showToast(type, message) {
    //   console.log(type);
    //   if (type == "success") {
    //     this.$toast.success(message, {
    //       position: "top-center",
    //       timeout: 1492,
    //       closeOnClick: true,
    //       pauseOnFocusLoss: false,
    //       pauseOnHover: false,
    //       draggable: false,
    //       draggablePercent: 0.41,
    //       showCloseButtonOnHover: false,
    //       hideProgressBar: true,
    //       closeButton: "button",
    //       icon: true,
    //       rtl: false,
    //     });
    //   }
    //   if (type == "error")
    //     this.$toast.error(message, {
    //       position: "top-center",
    //       timeout: 1492,
    //       closeOnClick: true,
    //       pauseOnFocusLoss: false,
    //       pauseOnHover: false,
    //       draggable: false,
    //       draggablePercent: 0.41,
    //       showCloseButtonOnHover: false,
    //       hideProgressBar: true,
    //       closeButton: "button",
    //       icon: true,
    //       rtl: false,
    //     });
    //   if (type == "warning")
    //     this.$toast.warning(message, {
    //       position: "top-center",
    //       timeout: 1492,
    //       closeOnClick: true,
    //       pauseOnFocusLoss: false,
    //       pauseOnHover: false,
    //       draggable: false,
    //       draggablePercent: 0.41,
    //       showCloseButtonOnHover: false,
    //       hideProgressBar: true,
    //       closeButton: "button",
    //       icon: true,
    //       rtl: false,
    //     });
    // },

    verModal() {
      this.$bvModal.show("nuevoServicio");
    },

    // exportToExcel() {
    //   // Crear las hojas de datos de cada array con títulos y sumatorias
    //   const sheet1 = this.createSheetWithSum(this.listaItems, "Prestaciones", "valorPrestacion");
    //   const sheet2 = this.createSheetWithSum(this.listaItemsMaterial, "Material Especial", "valor");
    //   const sheet3 = this.createSheetWithSum(this.listaLaboratorio, "Costos Laboratorio", "valorPrestacion");

    //   // Crear un nuevo libro de trabajo
    //   const wb = XLSX.utils.book_new();

    //   // Agregar cada hoja de trabajo con el nombre deseado
    //   XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sheet1), "Prestaciones");
    //   XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sheet2), "Material Especial");
    //   XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sheet3), "Costos Laboratorio");

    //   // Exportar el archivo Excel
    //   // XLSX.writeFile(wb, 'datos_separados.xlsx');
    //   XLSX.writeFile(wb, "Liquidación-" + this.profesional + "-" + this.mesSeleccionado + "-" + this.anioSeleccionado + "-" + this.sucursal + ".xlsx");
    // },

    // Función para crear una hoja con sumatoria
    // createSheetWithSum(data, title, sumColumn) {
    //   // Verificar si el array de datos está vacío
    //   if (!data || data.length === 0) {
    //     console.warn(`El array ${title} está vacío o no está definido.`);
    //     return [[title], ["No hay datos disponibles"]]; // Retorna un mensaje si el array está vacío
    //   }

    //   const headers = Object.keys(data[0]); // Obtener encabezados de las claves del array
    //   const sheetData = [];

    //   // Agregar los encabezados de las columnas
    //   sheetData.push(headers);

    //   // Agregar los datos del array
    //   data.forEach((item) => {
    //     sheetData.push(headers.map((key) => item[key]));
    //   });

    //   // Calcular y agregar la fila de sumatoria
    //   const sumRow = headers.map((key) => (key === sumColumn ? this.sumColumn(data, key) : ""));
    //   sheetData.push(["Total", ...sumRow.slice(1)]); // Agregar 'Total' y la sumatoria

    //   return sheetData;
    // },

    // Función para calcular la sumatoria de una columna específica
    // sumColumn(data, column) {
    //   return data.reduce((sum, item) => {
    //     const value = Number(item[column]); // Convertir a número
    //     return sum + (isNaN(value) ? 0 : value); // Sumar solo si es un número válido
    //   }, 0);
    // },

    async filtrar() {
      try {
        this.$isLoading(true);
        this.liquidaciones = [];
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ListaLiquidados/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
        });
        res = res.sort((a, b) => a.contador - b.contador);

        this.liquidaciones = res;
        let liquidados = this.liquidaciones.filter((x) => x.contador > 0);
        this.liquidados = liquidados.length;
        let pendientes = this.liquidaciones.filter((x) => x.contador == 0);
        this.pendientes = pendientes.length;

        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
      }
    },
    //   this.otrosConceptos = [];
    //   this.listaItems = [];
    //   if (item == 1) {
    //     this.profesional = null;
    //     this.sucursal = null;
    //     ////////
    //     this.$isLoading(true);
    //     //filtrar x mes y año
    //     let mesSeleccionado = new Date(this.anioSeleccionado + "/" + this.mesSeleccionado + "/01").getMonth();
    //     let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
    //     this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(anioSeleccionado, mesSeleccionado);
    //     await this.getData(this.Periodo.primerDia, this.Periodo.ultimoDia);

    //     this.$isLoading(false);
    //   }
    //   if (item == 2) {
    //     //problema: no existe rut del profesional en prestaciones
    //     try {
    //       this.$isLoading(true);

    //       //filtrando materiales si ha seleccionado profesional y sucursal
    //       let mesSeleccionado = new Date(this.anioSeleccionado + "/" + this.mesSeleccionado + "/01").getMonth();
    //       let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
    //       this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(anioSeleccionado, mesSeleccionado);
    //       console.log("periodo", this.Periodo);
    //       await this.obtenerData(this.Periodo.primerDia, this.Periodo.ultimoDia);
    //       // obtener otros conceptos
    //       await this.obtenerOtrosConceptos(this.Periodo.primerDia, this.Periodo.ultimoDia);
    //       this.listattos = this.listaItems.filter((x) => x.concepto == "Ttos. realizados, cancelados y evolucionados");
    //       this.listaItemsMaterial = this.listaItems.filter((x) => x.concepto == "Costos material especial");
    //       this.listaItemsRemision = this.listaItems.filter((x) => x.concepto == "Costos de remisión");

    //       this.listaLaboratorio = this.listaItems.filter((x) => x.concepto == "Costos Laboratorio");

    //       // totalizando datos

    //       this.totalAgregados = 0;
    //       this.totalDescuentos = 0;
    //       // this.otrosConceptos.forEach((item) => {
    //       //   if (item.tipo === "Descuento") {
    //       //     this.totalDescuentos += item.valor;
    //       //   }
    //       //   // else if (item.tipo === "Agregado") {
    //       //   //   this.totalAgregados += item.valor;
    //       //   // }
    //       // });
    //       //// CALCULANDO AGREGADOS Y DESCUENTOS DE OTROS CONCEPTOS
    //       let listaAgregados = this.otrosConceptos.filter((x) => x.tipo != "Descuento");
    //       let totalAgregados = listaAgregados.reduce((accumulator, currentItem) => {
    //         const valueToAdd = parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);
    //       //this.totalAgregados = totalAgregados;

    //       let listaDescuentos = this.otrosConceptos.filter((x) => x.tipo == "Descuento");
    //       let totalDescuentos = listaDescuentos.reduce((accumulator, currentItem) => {
    //         const valueToAdd = parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);
    //       //this.totalDescuentos = totalDescuentos;

    //       //CALCULANDO AGREGADOS Y DESCUENTOS DE LISTAITEMS
    //       let listaAgregadosttos = this.listaItems.filter((x) => x.tipo != "Descuento");
    //       let totalAgregadosttos = listaAgregadosttos.reduce((accumulator, currentItem) => {
    //         const valueToAdd = parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);

    //       let listaDescuentosttos = this.listaItems.filter((x) => x.tipo == "Descuento");
    //       let totalDescuentosttos = listaDescuentosttos.reduce((accumulator, currentItem) => {
    //         const valueToAdd = parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);

    //       this.totalDescuentos = Number(totalDescuentosttos) + Number(totalDescuentos);
    //       this.totalAgregados = Number(totalAgregadosttos) + Number(totalAgregados);
    //       this.totalNetoHonorarios = Number(this.totalAgregados) - Number(this.totalDescuentos);

    //       ///calculos totales///////////////////////////////////////////

    //       this.totalTtosRealizados = this.listaItems.reduce((accumulator, currentItem) => {
    //         const valueToAdd = Number(currentItem.porcentaje) > 0 ? parseFloat(currentItem.valorPrestacionSub) : parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);

    //       this.totalCostosMaterial = this.listaItemsMaterial.reduce((accumulator, currentItem) => {
    //         const valueToAdd = parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);

    //       this.totalCostosRemision = this.listaItemsRemision.reduce((accumulator, currentItem) => {
    //         const valueToAdd = parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);

    //       this.totalCostosLaboratorio = this.listaLaboratorio.reduce((accumulator, currentItem) => {
    //         const valueToAdd = parseFloat(currentItem.valor);
    //         return accumulator + valueToAdd;
    //       }, 0);
    //       // let sumatorias = parseFloat(this.listattos) + parseFloat(this.totalAgregados);
    //       // let descuentos = parseFloat(this.totalCostosLaboratorio) + parseFloat(this.totalCostosRemision) + parseFloat(this.totalDescuentos);

    //       //this.totalNetoHonorarios = ; //sumatorias - descuentos;

    //       this.$forceUpdate();
    //       this.$isLoading(false);
    //     } catch (error) {
    //       this.$isLoading(false);
    //     }
    //     //console.log("profesional data", this);
    //     // idProfesional = idProfesional[0].rut;
    //     // console.log("profesional data", idProfesional);
    //   }
    // },
    // async obtenerData(primerDia, ultimoDia) {
    //   console.log("proff", this.profesional.nombreProfesional);
    //   this.listaItems = [];
    //   let res = await this.$store.dispatch("denti_get", {
    //     path: "Prestaciones/MiHonorarioPorProfesionalFecha/" + this.profesional.nombreProfesional + "/" + primerDia + "/" + ultimoDia,
    //   });
    //   console.log("otros", res);
    //   this.listaItems = res;
    // },
    // async obtenerOtrosConceptos(primerDia, ultimoDia) {
    //   this.otrosConceptos = [];
    //   let res = await this.$store.dispatch("denti_get", {
    //     path: "Prestaciones/ListaOtrosConceptosPorProfesional/" + primerDia + "/" + ultimoDia + "/" + this.profesional.nombreProfesional + "/",
    //   });
    //   console.log("otros", res);
    //   this.otrosConceptos = res;
    // },

    // obtenerPrimerYUltimoDiaDelMes(anio, mes) {

    //   const primerDia = new Date(anio, mes, 1);
    //   const ultimoDia = new Date(anio, mes + 1, 0);

    //   return {
    //     primerDia: primerDia.toISOString().split("T")[0],
    //     ultimoDia: ultimoDia.toISOString().split("T")[0],
    //   };
    // },
    async getData(primerDia, ultimoDia) {
      try {
        if (window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
          window.$("#datatable_registroServicios").DataTable().destroy();
        }
        this.listaItems = [];
        // console.log("getdata dentisalud", Periodo);
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ListaProfesionalesPorPeriodo/" + primerDia + "/" + ultimoDia,
        });
        console.log("res dentisalud ", res);

        this.listaProfesional = res.map((x) => ({
          // console.log(x.profesional.nombreProfesional);
          nombreProfesional: x.profesional.nombreProfesional,
        }));

        // this.listaSucursal = res.map((pa) => pa.sucursalPpto).filter((nombrep, indexp, selfp) => selfp.indexOf(nombrep) === indexp);
        // this.listaSucursal.sort((a, b) => {
        //   if (a < b) return -1;
        //   if (a > b) return 1;
        //   return 0;
        // });

        // console.log("pacientes ", this.listaPacientes);
        // console.log("list registroServicios...", res);
        // if (res.success) {
        //   this.listaItems = res.data.map((service) => {
        //     return {
        //       ...service,
        //       placa: this.getPlacaVehiculo(service.placaId),
        //       estado: service.fechaFin ? true : false,
        //     };
        //   });
        //   // console.log(this.listaItems);
        // } else {
        //   this.listaItems = [];
        // }
        this.$isLoading(false);

        // this.$nextTick(function () {
        //   if (!window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
        //     window.$("#datatable_registroServicios").DataTable();
        //   }
        // });

        // core.index();

        // if (window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
        //   window.$("#datatable_registroServicios").DataTable().destroy();
        // }
        // this.dataTableInstance = window.$("#datatable_registroServicios").DataTable({
        //   language: {
        //     url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        //   },
        // });
        // this.$forceUpdate();
      } catch (error) {
        this.$isLoading(false);

        this.listaItems = [];
        console.log("err dentisalud ", error);
      }
    },
  },
};
</script>

<style scoped>
.custom-popup {
  background-color: #f0f8ff;
  border-radius: 10px;
  padding: 1em;
  font-size: 1rem !important;
}

.custom-title {
  color: #333;
  font-size: 0.5rem !important;
  font-weight: bold;
}

.custom-input {
  border: 1px solid #ddd;
  padding: 0.5em;
  border-radius: 5px;
}

.custom-confirm-button {
  background-color: #4caf50;
  color: white;
  padding: 0.5em 1.5em;
}

.custom-cancel-button {
  background-color: #f44336;
  color: white;
}
</style>
